import { render, staticRenderFns } from "./agentRole.vue?vue&type=template&id=1d396923"
import script from "./agentRole.vue?vue&type=script&lang=js"
export * from "./agentRole.vue?vue&type=script&lang=js"
import style0 from "./agentRole.vue?vue&type=style&index=0&id=1d396923&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports